import { render, staticRenderFns } from "./comp_ProductSheetDefault.vue?vue&type=template&id=438d710f&scoped=true&"
import script from "./comp_ProductSheetDefault.vue?vue&type=script&lang=js&"
export * from "./comp_ProductSheetDefault.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductSheetDefault.vue?vue&type=style&index=0&id=438d710f&prod&lang=css&"
import style1 from "./comp_ProductSheetDefault.vue?vue&type=style&index=1&id=438d710f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d710f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRating,VRow})
